<template>
	<div class="page-visitor page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">访客信息</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>访客信息</el-breadcrumb-item>
							<el-breadcrumb-item>访客信息列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
              <el-table-column prop="imgId" align="center" label="人脸图片" min-width="100">
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.imgId"
                    :src="baseUrl + '/api/sys/file/download?attachId=' + scope.row.imgId"
                    :preview-src-list="[baseUrl + '/api/sys/file/download?attachId=' + scope.row.imgId]"
                    fit="cover"
                    style="width: 40px; height: 40px; cursor: pointer;"
                  ></el-image>
                  <span v-else>-</span>
                </template>
              </el-table-column>
							<el-table-column prop="name" align="center" label="访客姓名" min-width="120"></el-table-column>
							<el-table-column prop="company" align="center" label="公司" min-width="160"></el-table-column>
              <el-table-column prop="mobile" align="center" label="手机号" min-width="140"></el-table-column>
              <el-table-column align="center" label="随访人" min-width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.followVisitors && scope.row.followVisitors.length > 0">
                    <div v-for="(visitor, index) in scope.row.followVisitors" :key="visitor.icode" style="margin-bottom: 5px;">
                      <el-image
                        v-if="visitor.imgId"
                        :src="baseUrl + '/api/sys/file/download?attachId=' + visitor.imgId"
                        :preview-src-list="[baseUrl + '/api/sys/file/download?attachId=' + visitor.imgId]"
                        fit="cover"
                        style="width: 30px; height: 30px; cursor: pointer; vertical-align: middle; margin-right: 5px;"
                      ></el-image>
                      <span>{{ visitor.name }} {{ visitor.mobile }}</span>
                    </div>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="remark" align="center" label="拜访事由" min-width="160" show-overflow-tooltip></el-table-column>
							<el-table-column align="center" label="拜访时间" min-width="280">
                <template slot-scope="scope">
                  {{scope.row.startTime.substring(0, 16)}} 至 {{scope.row.endTime.substring(0, 16)}}
                </template>
              </el-table-column>
							<el-table-column prop="buildingName" align="center" label="所在楼宇" min-width="140"></el-table-column>
							<el-table-column prop="createUserName" align="center" label="创建人" min-width="120"></el-table-column>
							<el-table-column prop="createdate" align="center" label="创建时间" min-width="160"></el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table_data.page_info.page" :page-sizes="[10,30,50,80,100]" :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next" :total="table_data.page_info.total"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'visitorList',
	data() {
		return {
			body_loading: false,
			baseUrl: this.$client.IMG_URL,
			table_data: {
				loading: false,
				list: [],
				page_info: {
					page: 1,
					pageSize: 10,
					total: 0
				}
			}
		}
	},
	created() {
		document.title = '访客信息';
		this.getList();
	},
	methods: {
		getList() {
			var _this = this;
			var params = {
				pageNo: _this.table_data.page_info.page,
				pageSize: _this.table_data.page_info.pageSize
			};
			_this.table_data.loading = true;
			this.$client.get('/api/biz/visitor/info/getListForAdmin', params, function(res, message, total) {
				_this.table_data.list = res;
				_this.table_data.page_info.total = total;
				_this.table_data.loading = false;
			}, function(res) {
				_this.table_data.loading = false;
			});
		},
		handleSizeChange(val) {
			this.table_data.page_info.pageSize = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.table_data.page_info.page = val;
			this.getList();
		}
	}
}
</script>
